import React, { useContext, useEffect, useState } from "react";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import Images from "../../Helpers/Images";
import { Link } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import BrandProfileDropdown from "./BrandProfileDropdown";
import InfluncerProfileDropdown from "./InfluncerProfileDropdown";
import CustomLoader from "./Loader/CustomLoader";

const Header = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { auth, setAuth, logOut } = useContext(Auth);
  useEffect(() => {
    getUser();
  }, []);
  const getUser = () => {
    let config = {
      url:
        auth?.userRole === "BRAND"
          ? ApiUrl.getBrandProfile
          : ApiUrl.getInfluncerProfile,
      method: "GET",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        localStorage.setItem("user", JSON.stringify(res?.data));

        setAuth({
          ...auth,
          user: res?.data,
        });
      },
      (err) => {
        setIsLoading(false);
      }
    );
  };

  return (
    <div className="header-wrapper">
      <div className="header-inner">
        <CustomLoader visible={isLoading} />
        <Navbar>
          <Container>
            <Navbar.Brand>
              <Link to="/influencer-dashboard">
                <img src={Images.logo} alt="logo" className="logo" />
              </Link>
            </Navbar.Brand>
            <div className="nav-right">
              <Nav className="">
                <Link to="/collaboration-hub">
                  <Nav>Collaboration Hub</Nav>
                </Link>
                {/* <Link to="/contact-us">
                  <Nav>Blog</Nav>
                </Link> */}
                <Link to="/contact-us">
                  <Nav>Contact</Nav>
                </Link>
              </Nav>
              {auth?.userRole === "BRAND" ? (
                <BrandProfileDropdown />
              ) : (
                <InfluncerProfileDropdown />
              )}
            </div>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;
